import { useEffect, useMemo, useState } from "react";
import { PlayerCardsContextData } from "./PlayerCardsContext";
import { LiquidVariable, PlayerCardServices } from "../../../services/bedrock";
import { useLocalStorage } from "../../../utils";
import { LiquidPlaceholderGroups, groupLiquidPlaceholders } from "../../../utils/liquidHelpers";

export interface PlaceholderContextData {
  placeholders: LiquidPlaceholderGroups;
  displayPlaceholders: boolean;
  setDisplayPlaceholders: (displayPlaceholders: boolean) => void;
}

export const InitialPlaceholderContextData: PlaceholderContextData = {
  placeholders: {},
  displayPlaceholders: true,
  setDisplayPlaceholders: () => {},
};

export const PlaceholderContext = (PlayerCards: PlayerCardsContextData): PlaceholderContextData => {
  const [displayPlaceholders, setDisplayPlaceholders] = useLocalStorage("displayPlayerCardPlaceholders", true);
  const [defaultLiquidVariables, setDefaultLiquidVariables] = useState<LiquidVariable[]>([]);

  useEffect(() => {
    PlayerCardServices.getLiquidVariables()
      .then(({ liquidVariables }) => setDefaultLiquidVariables(liquidVariables))
      .catch(console.error);
  }, []);

  const placeholders = useMemo(
    () => groupLiquidPlaceholders(PlayerCards.selectedPlayerCard?.liquidVariables || defaultLiquidVariables),
    [PlayerCards.selectedPlayerCard?.liquidVariables, defaultLiquidVariables]
  );

  return {
    placeholders,
    displayPlaceholders,
    setDisplayPlaceholders,
  };
};
